import cartFunctions from './cartFunctions';

export default {
  functions: [
    ...cartFunctions,
    {
      name: 'getODPOrder',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'odpOrder',
      },
    },
    {
      name: 'getODPProducts',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'odpProducts',
      },
    },
  ],
};
